import ApiCaller from 'actions/ApiCaller';
import baseAjaxConfig from 'actions/BaseAjaxConfig';
export var staticPageAction;
(function (staticPageAction) {
    staticPageAction["REQUEST"] = "STATIC_PAGE_REQUEST";
    staticPageAction["SUCCESS"] = "STATIC_PAGE_SUCCESS";
    staticPageAction["ERROR"] = "STATIC_PAGE_ERROR";
})(staticPageAction || (staticPageAction = {}));
export default function fetchStaticPage(pageId = 'obd-know-more') {
    return (dispatch) => {
        dispatch({
            type: staticPageAction.REQUEST
        });
        return ApiCaller.post(Object.assign({}, baseAjaxConfig, {
            pathname: `/api/4/page/fetch`,
            action: staticPageAction.REQUEST
        }), { pageUri: `/${pageId}` }).then(json => dispatch({
            type: staticPageAction.SUCCESS,
            data: json.RESPONSE
        }), error => {
            dispatch({
                type: staticPageAction.ERROR,
                error
            });
        });
    };
}
